export default function(customDimensionsObject) {
    if (!customDimensionsObject || !Object.keys(customDimensionsObject)?.length) return;
    const root = document.querySelector(':root');
    Object.keys(customDimensionsObject).forEach(key => {
        root.style.setProperty(key, customDimensionsObject[key]);
    });
}